import React from 'react';
import QuestionMark from '../../../assets/images/form_screen/question_mark.png';
import waveBg from '../../../assets/images/home_screen/wave-bg.svg';
function GotQuestion() {
  return (
    <div className="relative min-w-full h-[600px] 2xl:h-[650px] 3xl:h-[750px] bg-gradient-to-r from-[#7F76AF] to-[#C572A7]">
      <div className="absolute -top-[50px] sm:-top-[100px] md:-top-[100px] lg:-top-[150px] xl:-top-[180px] 2xl:-top-[220px] 3xl:-top-[250px] 4xl:-top-[280px] 5xl:-top-[350px] left-0 max-w-screen overflow-hidden z-20">
        <img
          src={waveBg}
          alt="wavy-svg-bg"
          className="w-[101vw] h-auto object-fill"
        />
      </div>
      <div className="max-w-[1200px] h-full w-full mx-auto px-4 md:px-10 flex flex-col md:flex-row items-start gap-4 sm:gap-10 xl:gap-32 z-50">
        <div className="flex flex-col items-start justify-center h-full gap-2 text-white mt-48 md:mt-12">
          <h1 className="text-white text-[40px] lg:text-[55px] 2xl:text-[65px] 3xl:text-[80px] font-bold tracking-wide uppercase">
            Got Questions?
          </h1>
          <p className="text-white text-[32px] 2xl:text-[45px] font-light cursor-pointer z-50">
            Call our friendly office staff at{' '}
            <a href="tel:+19073764880">907-376-4880</a>
          </p>
        </div>
        <div className="flex-1">
          <img
            src={QuestionMark}
            alt="QuestionMark"
            className="mix-blend-multiply absolute top-0 right-0 h-full w-full md:w-auto object-cover"
          />
        </div>
      </div>
    </div>
  );
}

export default GotQuestion;
